// extracted by mini-css-extract-plugin
export default {"readMoreButtonWrapper":"style_readMoreButtonWrapper__+C0PE","readMoreButton":"style_readMoreButton__yRKkA"};